export default {
  '1': 'Comprando un voucher Classic también accedés a todo el inventario de economy',
  '2': 'Comprando un voucher premium también accedés a todo el inventario de classic y economy',
  '3': null,
};
